import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chart-loading-placeholder',
  templateUrl: './chart-loading-placeholder.component.html',
  styleUrls: ['./chart-loading-placeholder.component.scss']
})
export class ChartLoadingPlaceholderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
